import React, { useEffect } from "react";
import { connect } from "react-redux";
import InsertInvitationIcon from "@material-ui/icons/InsertInvitation";
import JirangoButton from "../../../components/UI/Buttons/JirangoButton";
import Axios from "axios";
import EventLabel2, { init } from "../../../../core/EventLabel2/EventLabel2";

const CalendarInvitation = (props) => {
  const { type, value, contentId, cms, template, settings } = props;

  useEffect(() => {
    const t = new Date();
    const { eventId, languageCode } = props.cms;
    init(eventId, "Cms.CalendarInvitation", languageCode || "swe");
  }, []);
  // const handleClick = () => {
  //   let badgeNo = props.attendee.orders[props.attendee.activePersonNo].badgeNo;
  //   if (!settings.invitationId) return;
  //   Axios.get(`./api/calendar/geticalfile/${settings.invitationId}?badgeNo=${badgeNo}`, {
  //     responseType: "arraybuffer",
  //   }).then((response) => {
  //     /*       fileSaver.saveAs(response, "Hej"); */
  //   });
  // };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: settings.alignment == "center" ? "center" : settings.alignment == "left" ? "flex-start" : "flex-end",
        width: "100%",
      }}
    >
      <a href={`./api/calendar/geticalfile/${settings.invitationId}?badgeNo=${props.badgeNo}`} download={"invitation.ical"}>
        <JirangoButton
          style={{
            ...props.template.template.content.button,
            margin: "auto",
            /*   padding: settings.padding, */
          }}
          disabled={!settings.invitationId || cms.editMode}
          settings={settings}
        >
          <InsertInvitationIcon /> {value || <EventLabel2 name="AddToCalendar" groupName="Cms.CalendarInvitation" />}
        </JirangoButton>
      </a>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    alert: state.alert,
    form: state.form,
    cms: state.cms,
    attendee: state.attendee,
    template: state.template,
    language: state.language,
    page: state.page,
    badgeNo: state.attendee && state.attendee.orders && state.attendee.orders.length > 0 ? state.attendee.orders[state.attendee.activePersonNo].badgeNo : "",
  };
}
export default connect(mapStateToProps)(CalendarInvitation);
